import { Injectable } from '@angular/core';
import { SETTINGS } from '../config/common.settings';
import { HttpClient } from '@angular/common/http';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { NzMessageService } from 'ng-zorro-antd/message';

@Injectable({
  providedIn: 'root',
})
export class MediaService {
  constructor(
    private http: HttpClient,
    private ngxLoader: NgxUiLoaderService,
    private message: NzMessageService,
  ) {}

  addMedia(data: any): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http.post(`${SETTINGS.CMS_API}/api/media`, data
      ).subscribe(
        (response) => {
          this.ngxLoader.stop();
          resolve(response);
        },
        (error) => {
          this.ngxLoader.stop();
          this.message.create('error', 'Failed to upload Image');
          reject(error);
        },
      );
    });
  }

  getAlbums(): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http.get(`${SETTINGS.CMS_API}/api/albums`,
        {withCredentials: true}
      ).subscribe(
        (response) => {
          this.ngxLoader.stop();
          resolve(response);
        },
        (error) => {
          this.ngxLoader.stop();
          this.message.create('error', 'Failed to get Albums');
          reject(error);
        },
      );
    });
  }

  getAlbumsById(id: string): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http.get(`${SETTINGS.CMS_API}/api/albums/${id}`,{withCredentials: true}).subscribe(
        (response) => {
          this.ngxLoader.stop();
          resolve(response);
        },
        (error) => {
          this.ngxLoader.stop();
          this.message.create('error', 'Failed to get Albums');
          reject(error);
        },
      );
    });
  }
}
